module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_gk_tldd.7e41ddb4.png";